 $('.js-togglenav').on('click', function(e){

 	$('body').toggleClass('nav-is-open')
 	$.magnificPopup.close()

  e.preventDefault()
})
